import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { OfferList } from '@/_store/offers/offers.types';
import { PipesModule } from '@/modules/shared/pipes/pipes.module';
import { MainService } from '@/main/services/main.service';
import { OffersFacade } from '@/_store/offers/offers.facade';

@Component({
	selector: 'app-offer-box-mobile-horizontal',
	templateUrl: './offer-box-mobile-horizontal.component.html',
	standalone: true,
	imports: [NgOptimizedImage, PipesModule, AsyncPipe],
})
export class OfferBoxMobileHorizontalComponent {
	readonly offer = input.required<OfferList>();

	readonly mainService = inject(MainService);
	readonly offersFacade = inject(OffersFacade);
}
